module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/desktop-f253b00cbbbf194877d2a891be298f72.webp";